<template>
  <span class="help-tip" tabindex="0" role="note" :aria-label="text">
    ?
    <md-tooltip class="help-tip-bubble" md-direction="top" :md-delay="0">{{ text }}</md-tooltip>
  </span>
</template>

<script>
export default {
  name: "HelpTip",
  props: {
    /** Erklaerungstext, Zeilenumbrueche (\n) bleiben erhalten. */
    text: { type: String, default: "" },
  },
};
</script>

<style scoped>
.help-tip {
  display: inline-block;
  width: 14px;
  height: 14px;
  line-height: 14px;
  text-align: center;
  font-size: 10px;
  font-weight: 600;
  color: #fff;
  background: #bbb;
  border-radius: 50%;
  cursor: help;
  vertical-align: middle;
  outline: none;
}
.help-tip:hover,
.help-tip:focus {
  background: #7f915a;
}
</style>

<style>
/* md-tooltip wird ausserhalb der Komponente (am body) gerendert, daher nicht scoped */
.md-tooltip.help-tip-bubble {
  z-index: 99999 !important;
  height: auto;
  max-width: 340px;
  padding: 8px 10px;
  line-height: 1.4;
  font-size: 12px;
  white-space: pre-line;
  text-align: left;
}
</style>
